import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { VehicleCardContext } from '../../../../configs/vehicle-card-view/state.manager'

const conditionIsActive = (conditionListActive, condition) => {
    return conditionListActive.some(({ conditionDefinition }) => conditionDefinition.code === condition)
}

const conditionInfo = (condition, classNames) => {
    const { label, backgroundColor, fontColor } = condition

    return (
        <span
            className={classNames}
            style={{
                backgroundColor,
                color: fontColor,
            }}
        >
            {label}
        </span>
    )
}

const VehicleConditions = ({ extraClasses, isHumberview }) => {
    const {
        state: {
            XMSConfig: { conditionsConfigurations },
            vehicle: { newVehicle, certified, demo },
        },
    } = React.useContext(VehicleCardContext)

    const classNames = clsx('vc-vehicleConditions', extraClasses)

    // TODO: Need to have config from XMS-Delta to display demo as new or used
    // For now with !demo flag and !isHumberview flag added into the condition, it will display Used label for all demo vehicles for Humberview websites only
    // For same code base for Volvo and Ford condition for demo vehicles taken from backend only
    const hasNewCondition = newVehicle && (!isHumberview || !demo) && conditionIsActive(conditionsConfigurations, 'new')
    const hasUsedCondition = !certified && conditionIsActive(conditionsConfigurations, 'used')

    if (hasNewCondition) {
        const newConditionInfo = conditionsConfigurations.filter(
            ({ conditionDefinition }) => conditionDefinition.code === 'new'
        )[0]
        return conditionInfo(newConditionInfo, classNames)
    }

    if (hasUsedCondition) {
        const usedConditionInfo = conditionsConfigurations.filter(
            ({ conditionDefinition }) => conditionDefinition.code === 'used'
        )[0]
        return conditionInfo(usedConditionInfo, classNames)
    }

    return null
}

VehicleConditions.propTypes = {
    /** Extra classes */
    extraClasses: PropTypes.string,
}

VehicleConditions.defaultProps = {
    extraClasses: '',
}
export default VehicleConditions
